import { GamingFromStrategyIcon, SocialFromStrategyIcon } from '@/svgs'
import React from 'react'

function SocialFromStrategy() {
   return (
      <section id="development-guide-section" className="section_secondary_bg">
         <div className="container">
            <h2 className="section_heading_title mb-3">
               From Connection to Engagement: Our Social & Dating Software
               Development Process
            </h2>

            <p className="section_desc">
               With 12+ years of expertise in social and dating software
               development, we build seamless, scalable, and high-performance
               solutions. Our structured approach enhances user interactions,
               strengthens security, and optimizes matchmaking algorithms.
            </p>

            <SocialFromStrategyIcon />
         </div>
      </section>
   )
}

export default SocialFromStrategy
